module.exports = __webpack_public_path__ + "media/application/images/ui/home-icon-174727b63e787af726406c6d996d2c34.png";